import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { ApiRequestError } from './api/client.js';
import './i18n/index.js';
import './styles/base.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Повторять запрос при отозванном доступе или отсутствии прав бессмысленно.
      retry: (failureCount, error) => {
        if (error instanceof ApiRequestError) {
          const fatal = ['UNAUTHENTICATED', 'SESSION_EXPIRED', 'FORBIDDEN', 'JIRA_DISCONNECTED'];
          if (fatal.includes(error.code)) return false;
        }
        return failureCount < 2;
      },
      /*
       * Возврат на вкладку перечитывает то, что успело устареть.
       *
       * Без этого открытая вкладка живёт ровно на тех данных, что получила при загрузке:
       * опрос по интервалу заведён только у разделов, уведомлений и хода синхронизации,
       * а таблица, план и заметки не обновляются вовсе. Оставленная на ночь страница
       * показывает вчерашнее состояние и выглядит зависшей.
       *
       * Частоту сдерживает staleTime каждого запроса: свежие данные при переключении вкладок
       * не перезапрашиваются, поэтому щёлканье по вкладкам не превращается в поток запросов.
       */
      refetchOnWindowFocus: true,
    },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('корневой элемент не найден');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
